import { AuthService } from './../../auth/services/auth.service';
import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { finalize, mergeMap, tap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { AlertsService, Result } from 'itcores-fw';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AuthTypeEnum } from '../../auth/models/auth-type-enum';
import { AuthResponse, ServerHashParamKeys } from 'msal';

@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {
  constructor(
    private alertsService: AlertsService,
    private authService: AuthService,
    private translate: TranslateService,
    private msalService: MsalService,
    private broadcastService: MsalBroadcastService
  ) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const authType = this.authService.getAuthType();
    if (authType === AuthTypeEnum.OIDC) {
      // For OIDC, just pass through the request for now
      // MSAL interceptor should handle OIDC token acquisition
      return next.handle(req);

    } else {
      const headersConfig = {};
      const token = this.authService.getToken();
      if (token) {
        headersConfig['Authorization'] = `Bearer ${token}`;
      }

      const request = req.clone({ setHeaders: headersConfig });

      // if GetById method
      if (request.url.indexOf('/Get/') !== -1) {
        return next.handle(request).pipe(
          finalize(() => {
          })
        );
      }

      if (request.method === 'POST' || request.method === 'PUT') {

        return next.handle(request).pipe(
          finalize(() => {
          }),
          tap((event: HttpResponse<Result>) => {
            if (event instanceof HttpResponse) {
              if (event.body && event.url.indexOf('authenticate') === -1) {
                this.translate.get('helpers.messages').subscribe((key: any) => {
                  if (event.body.message !== null && event.body.message !== '') {
                    if (event.body.success) {
                      this.alertsService.successMessage(
                        event.body.message || key['successAdd'],
                      );
                    } else {
                      this.alertsService.errorMessage(
                        event.body.message || key['errroMessage']
                      );
                    }
                  }
                });
              }
            }
          })
        );
      } else {

        // check if there is success message in get method
        if (request.method.toLowerCase() === 'get') {
          return next.handle(request).pipe(
            finalize(() => { }),
            tap((event: HttpResponse<Result>) => {
              if (event instanceof HttpResponse) {
                const evBody = event.body;
                if (evBody.message && evBody.success === false) {
                  this.alertsService.errorMessage(evBody.message);
                }
              }
            })
          );
        }
        return next.handle(request);
      }
    }
  }
}
